import type { PostApiV1RefundsCancelSubscription200AllOf } from './postApiV1RefundsCancelSubscription200AllOf';
import type { PostApiV1RefundsCancelSubscription200AllOfThree } from './postApiV1RefundsCancelSubscription200AllOfThree';

export type PostApiV1RefundsCancelSubscription200 = PostApiV1RefundsCancelSubscription200AllOf & PostApiV1RefundsCancelSubscription200AllOfThree;
